import { render, staticRenderFns } from "./ArriveAddressCostList.vue?vue&type=template&id=4db3e4fc&scoped=true"
import script from "./ArriveAddressCostList.vue?vue&type=script&lang=js"
export * from "./ArriveAddressCostList.vue?vue&type=script&lang=js"
import style0 from "./ArriveAddressCostList.vue?vue&type=style&index=0&id=4db3e4fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3e4fc",
  null
  
)

export default component.exports